module.exports = __webpack_public_path__ + "img/success.a1a258a8.png";